import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=f29918c0&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=f29918c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29918c0",
  null
  
)

export default component.exports